import { createFileRoute } from '@tanstack/react-router'

import { HighLowTicketsScreen } from './-components/high-low-tickets-screen.tsx'

export const Route = createFileRoute(
  '/transaction-monitoring/high-low-tickets'
)({
  component: HighLowTicketsScreen
})
